<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>

<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48">
    <path
        d="M929.792 514.048l-409.6 190.464-423.936-204.8c-18.432-10.24-40.96-2.048-51.2 16.384s-2.048 40.96 16.384 51.2L501.76 778.24c6.144 2.048 12.288 4.096 16.384 4.096s12.288-2.048 14.336-4.096l425.984-196.608c18.432-10.24 26.624-32.768 18.432-51.2-4.096-16.384-26.624-24.576-47.104-16.384z"
    ></path>
    <path
        d="M63.488 344.064l440.32 210.944c6.144 2.048 12.288 4.096 16.384 4.096s12.288-2.048 14.336-4.096l425.984-196.608c12.288-6.144 20.48-18.432 22.528-34.816 0-14.336-8.192-28.672-20.48-34.816L534.528 73.728c-10.24-6.144-22.528-6.144-34.816 0L63.488 276.48c-12.288 6.144-20.48 18.432-22.528 34.816 2.048 12.288 10.24 24.576 22.528 32.768z m450.56-196.608L860.16 323.584l-337.92 155.648-356.352-169.984 348.16-161.792zM929.792 686.08l-409.6 190.464-423.936-202.752c-18.432-10.24-40.96-2.048-51.2 16.384s-2.048 40.96 16.384 51.2l440.32 210.944c6.144 2.048 12.288 4.096 16.384 4.096s12.288-2.048 14.336-4.096l425.984-196.608c18.432-10.24 26.624-32.768 18.432-51.2-4.096-18.432-26.624-26.624-47.104-18.432z"
    ></path>
  </svg>
</template>

<style scoped>

</style>